import React, { useMemo } from 'react';
import BaseInput from '../Base/BaseInput';
import BaseSelect from '../Base/BaseSelect';
import { Passes } from '../../models/PassesModel';
import PassDetailFieldsPanel from './PassDetailFieldsPanel';
import { resolvePassTypeFromName } from '../../pages/Companies/Passes/passFieldConfig';
import {
  finalizeFormTextField,
  sanitizeFormTextField,
} from '../../utils/textInputSanitize';
import './styles/PassDetailFieldsPanel.css';

type Props = {
  value: Passes;
  onChange: (p: Passes) => void;
  companies: { value: string; label: string }[];
  error?: string | null;
  fieldErrors?: Record<string, string>;
  showPassDetail?: boolean;
};

const PassesForm: React.FC<Props> = ({
  value,
  onChange,
  companies,
  fieldErrors = {},
  showPassDetail = false,
}) => {
  const passType = useMemo(
    () => resolvePassTypeFromName(value.name ?? ''),
    [value.name]
  );

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value: v } = e.target;
    onChange({
      ...value,
      [name]: name === 'company' ? Number(v) : v,
    });
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    onChange({ ...value, [name]: sanitizeFormTextField(name, v) });
  };

  const handleTextBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    const next = finalizeFormTextField(name, v);
    if (next !== (value as any)[name]) {
      onChange({ ...value, [name]: next });
    }
  };

  return (
    <div className="passes-form">
      <div className="form-row">
        <div className="form-field full-width">
          <BaseSelect
            label="Empresa"
            name="company"
            value={String(value.company ?? '')}
            onChange={handleSelectChange}
            options={companies.map((c) => ({ value: String(c.value), label: c.label }))}
            placeholder="Seleccionar empresa"
          />
          {fieldErrors.company && (
            <div className="form-error" role="alert">
              {fieldErrors.company}
            </div>
          )}
        </div>
      </div>

      <div className="form-row">
        <div className="form-field full-width">
          <BaseInput
            label="Nombre del pase"
            name="name"
            value={value.name ?? ''}
            onChange={handleTextChange}
            onBlur={handleTextBlur}
            required
            maxLength={120}
            error={fieldErrors.name}
          />
        </div>
      </div>

      {showPassDetail && passType && (
        <PassDetailFieldsPanel definition={passType} />
      )}

      {showPassDetail && !passType && value.name?.trim() && (
        <p className="pass-detail__empty">
          No hay campos definidos para este tipo de pase. Usa un nombre reconocido
          (El Abra, Enaex, DMH o DGM) para ver el detalle.
        </p>
      )}
    </div>
  );
};

export default PassesForm;
